export const MenuItems = [
    // {
    //     title: 'Public Gallery',
    //     path: '/gallery',
    //     cName: 'dropdown-link',
    // },
    {
        title: 'Profile',
        path: '/profile/9/1',
        cName: 'dropdown-link',
    },
    {
        title: 'Settings',
        path: '/settings',
        cName: 'dropdown-link',
    },
    {
        title: 'Log Out',
        path: '/logout',
        cName: 'dropdown-link',
    },
]